module.exports = {
        srcSet: __webpack_public_path__ + "bcd80726bf5d8c37-600.webp"+" 600w"+","+__webpack_public_path__ + "44b1b8a411640f2a-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "bcd80726bf5d8c37-600.webp",width: 600,height: 326},{path: __webpack_public_path__ + "44b1b8a411640f2a-1000.webp",width: 1000,height: 545}],
        src: __webpack_public_path__ + "44b1b8a411640f2a-1000.webp",
        toString: function(){return __webpack_public_path__ + "44b1b8a411640f2a-1000.webp"},
        
        width: 1000,
        height: 545
      }